















































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateDepositFixedTermSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/FixedTerm/UpdateDepositFixedTermSettingsRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue'
import ListUtils from '@/lib/listUtils';
import PeriodType from '@/models/Shared/PeriodType';

@Component({ name: 'AccountDepositFixedTermSettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    fundingWindowStartDateAsString: string = '';
    autoCloseDateAsString: string = '';
    request: UpdateDepositFixedTermSettingsRequest = new UpdateDepositFixedTermSettingsRequest(null, null, null);
    PeriodType = PeriodType;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateDepositFixedTermSettingsRequest(DepositAccountSettingsModule.settings.depositFixedTermSettings, new Date(), this.defaultWalletCurrency);
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositFixedTermSettings;
    }

    get defaultWalletCurrency () {
        return DepositAccountSettingsModule.productIssue.generalSettings.defaultWalletCurrency;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            await DepositAccountSettingsModule.editDepositFixedTermSettings(this.request);
        }
    }

}
